import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { debounce } from 'throttle-debounce';
import { $Elements, BrowserEvents, Classes, MobileBreakpoint } from './constants';
import { updateOnResize } from './helpers';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

;(function($) {

	const mainController = new ScrollMagic.Controller();
	const mobileController = new ScrollMagic.Controller();
	const desktopController = new ScrollMagic.Controller();

	$Elements.document.on(BrowserEvents.page.enter, function() {

		//=====================================
		//	!---------- ANIMATIONS ----------
		//=====================================

		// ---------- Global ----------

		$('.animated-section:not(.clone)').each(function() {

			const self = $(this);

			const sectionScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: 0.8, reverse: false })
				.setClassToggle(this, Classes.active)
				.addTo(mainController);

			updateOnResize(() => sectionScene.progress(1));
		});

		// ---------- Parallax ----------

		$('.parallax-section:not(.fixed-parallax-section):not(.clone)').each(function() {

			const self = $(this);
			const image = self.find('.parallax-image');
			const speed = 50;
			const tween = new TimelineMax()
				.fromTo(image, 1, { y: '-' + speed + '%', ease: Linear.easeNone }, { y: speed + '%', ease: Linear.easeNone })

			const parallaxScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: 'onEnter', duration: '200%' })
				.setTween(tween)
				.addTo(desktopController);

			updateOnResize(() => parallaxScene.progress(0.5));
		});

		// ---------- Controller ----------

		updateOnResize(() => {
			desktopController.enabled(false);
			mobileController.enabled(true).update(true);
		}, () => {
			desktopController.enabled(true).update(true);
			mobileController.enabled(false);
		});

		$Elements.window.trigger('resize');
	});

}(jQuery));
